import { render, staticRenderFns } from "./PlayerManagement.vue?vue&type=template&id=11c59126&scoped=true"
import script from "./PlayerManagement.vue?vue&type=script&lang=js"
export * from "./PlayerManagement.vue?vue&type=script&lang=js"
import style0 from "./PlayerManagement.vue?vue&type=style&index=0&id=11c59126&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11c59126",
  null
  
)

export default component.exports